import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  compose,
  JOURNEY_STEP_STATUS,
} from '../../../../services/utilityFunctions';
import Request from '../../../../services/request';
import Notifications from '../../../../services/notifications';
import JourneyStepProp from '../../propTypes/journeyStepProp';
import withCSRF from '../../../../commonComponents/withCSRF';
import translate from '../../../../commonComponents/translate';
import SkipStepButton from '../../overall/content/components/SkipStepButton';
import { useSanitize } from '../../../../services/customHooks';

function TaskForm({ t, _csrf, step, onDone, onSkipStep }) {
  const [isLoading, setIsLoading] = useState(false);
  const isDone = useMemo(
    () => step.status === JOURNEY_STEP_STATUS.DONE,
    [step.status],
  );
  const handleDone = () => {
    setIsLoading(true);
    new Request(_csrf)
      .post(`/journey/step/${step._id}/done`)
      .done(() => {
        Notifications.showNotificationSuccess(
          t('success'),
          t('journey_taskDone'),
        );
        if (onDone) {
          onDone();
        }
        setIsLoading(false);
      })
      .fail(err => {
        Notifications.showErrorFromRequest(err, 'error_taskDone');
        setIsLoading(false);
      });
  };

  const submitButtonClasses = cx(
    'btn m-btn btn-dynamic',
    { 'm-loader': isLoading },
    { 'm-loader--right': isLoading },
    { 'm-loader--light': isLoading },
  );

  const description = useSanitize(step.description);

  return (
    <>
      <div className="row">
        <div className={`${onSkipStep ? 'col-6' : 'col-12'} task-description`}>
          <div
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </div>
        {onSkipStep && (
          <div className="col-6 skip-wrapper m-0">
            <SkipStepButton onClick={onSkipStep} />
          </div>
        )}
      </div>
      <div className="mark-done-container">
        <button
          type="button"
          disabled={isDone || isLoading}
          className={submitButtonClasses}
          onClick={handleDone}
        >
          <i
            className="la la-check"
            style={{ marginRight: '5px', marginBottom: '5px' }}
          />
          {isDone ? t('journey_isDone') : t('journey_markAsDone')}
        </button>
      </div>
    </>
  );
}

TaskForm.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
  onDone: PropTypes.func,
  onSkipStep: PropTypes.func,
};

TaskForm.defaultProps = {
  onDone: null,
  onSkipStep: null,
};

export default compose(translate, withCSRF)(TaskForm);
